import { MultilayerBagsFields } from "./types";

// export const dimensionsCheckboxes: Array<MultilayerBagsFields> = [
//   MultilayerBagsFields["minigrip-slider"],
//   MultilayerBagsFields.euro,
//   MultilayerBagsFields.tear,
//   MultilayerBagsFields.window,
//   MultilayerBagsFields.butterfly,
//   MultilayerBagsFields.cap,
//   MultilayerBagsFields.handles,
// ];

export const dimensionsInput: Array<
  | MultilayerBagsFields.length
  | MultilayerBagsFields.width
  | MultilayerBagsFields.folding
> = [
  MultilayerBagsFields.length,
  MultilayerBagsFields.width,
  MultilayerBagsFields.folding,
];
